import {
  IConditionDefinition,
  IExpression,
  Operator
} from '@/services/Hub/notificationCenter/types';
import { RuleGroupType, RuleType } from 'react-querybuilder';

// TODO (s4hlo) needs tests
/**
 * Converts a MongoDB query to react-querybuilder RuleGroupType format
 * @param mongoQuery MongoDB query object
 * @returns RuleGroupType for react-querybuilder
 */
export function conditionEngineToRuleGroup(conditions: IConditionDefinition): RuleGroupType {
  if (!conditions || !conditions.expressions || conditions.expressions.length === 0) {
    return {
      combinator: 'and',
      rules: []
    };
  }

  // If no structure is defined, treat all expressions as AND
  if (!conditions.expressionsStructure || conditions.expressionsStructure.length === 0) {
    return {
      combinator: 'and',
      rules: conditions.expressions.map(expression => convertExpressionToRule(expression))
    };
  }

  // Handle structured expressions
  // Each row in expressionsStructure represents a scenario (AND group)
  // Multiple rows represent OR scenarios
  if (conditions.expressionsStructure.length === 1) {
    // Single scenario - all expressions in AND
    const scenarioIndices = conditions.expressionsStructure[0];
    return {
      combinator: 'and',
      rules: scenarioIndices.map(index => convertExpressionToRule(conditions.expressions[index]))
    };
  }

  // Multiple scenarios - each scenario is AND, scenarios are OR
  return {
    combinator: 'or',
    rules: conditions.expressionsStructure.map(scenarioIndices => ({
      combinator: 'and' as const,
      rules: scenarioIndices.map(index => convertExpressionToRule(conditions.expressions[index]))
    }))
  };
}

/**
 * Converts a single expression to RuleType
 */
function convertExpressionToRule(expression: IExpression): RuleType {
  const operator = mapOperatorToReactQueryBuilder(expression.operation);

  // Handle unary operators (present/blank)
  let value = expression.value;
  if (expression.operation === 'present') {
    value = 'true';
  } else if (expression.operation === 'blank') {
    value = 'false';
  }

  return {
    field: expression.fieldIdentifier?.replace(/_/g, '.'),
    operator,
    value
  };
}

/**
 * Maps condition engine operators to react-querybuilder operators
 */
function mapOperatorToReactQueryBuilder(operation: Operator): string {
  switch (operation) {
    case 'equals':
      /** we are converting to in to make it work as a multi-select */
      return 'in';
    case 'not_equals':
      /** we are converting to nin to make it work as a multi-select */
      return 'nin';
    case 'greater_than':
      return 'gt';
    case 'less_than':
      return 'lt';
    case 'includes':
      return 'in';
    case 'not_includes':
      return 'nin';
    case 'present':
      return 'exists';
    case 'blank':
      return 'exists';
    case 'has_size_equals_to':
      return 'eq'; // This might need special handling for array size
    case 'between':
      // TODO (s4hlo) update to create two expressions one gt and one lt
      return 'lt';
    default:
      return 'eq';
  }
}
